import type { OptumPayerIdSource } from 'ts-back-end/src/business/insurance-verification/types/types'

export const BILLING_LOCATION_CODES = [
  { key: '9', value: 'Sleep Solutions HST' },
  { key: '10', value: 'Sleep Solutions PO.' },
  { key: '7', value: 'TestSmarter HST – FL' },
  { key: '8', value: 'TestSmarter HST – NE' },
  { key: '3', value: 'TestSmarter - FL' },
  { key: '4', value: 'TestSmarter - NE' },
]

export const billingLocationCodeLookup = BILLING_LOCATION_CODES.reduce<{ [key: string]: string }>(
  (acc, val) => {
    acc[val.key] = val.value
    return acc
  },
  {},
)

export const OPTUM_PAYER_ID_FIELDS = ['uPayerId', 'optumPayerId', 'optumClaimsPayerId'] as const

// Saved Optum IDs the back end drops when the payor ID changes without new ones.
export const OPTUM_RESOLVED_PAYER_ID_LABELS = {
  optumPayerId: 'Optum Eligibility Payer ID',
  optumClaimsPayerId: 'Optum Claims Payer ID (CPID)',
} as const

export const OPTUM_PAYER_ID_SOURCE_LABELS: Record<`${OptumPayerIdSource}`, string> = {
  PAYOR_ID: 'Payor ID',
  OVERRIDE: 'Optum ID override',
  CROSSWALK: 'legacy crosswalk',
}

export const OPTUM_PAYER_CHECK_MESSAGES = {
  eligibilityUnrecognized:
    "Optum doesn't recognize this payer ID for eligibility; eligibility checks may fail.",
  claimsUnrecognized: "Optum doesn't recognize this payer ID; claims may be rejected.",
  multipleMatches: 'Optum has several payers under this ID. Make sure the intended one is listed.',
  unavailable: "Couldn't verify the payer ID with Optum right now.",
  resolvedIdsCleared:
    'These Optum IDs belong to the previous payor ID and will be cleared, then looked up again from the new one:',
}
